import React, { useState, useEffect } from 'react';
import FileData from '../components/dataForm/filesData';
import useWindowSize from '../utils/useWindowSize';
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { database } from "../utils/fipresConfig";
import "../style/pages.css";
import "../style/files.css"
import { AiOutlineClose } from "react-icons/ai";
import { RxHamburgerMenu } from "react-icons/rx";
import { MagnifyingGlass } from 'react-loader-spinner';
export default function Files({ onEditClick, onDeleteClick }) {
  const [files, setFiles] = useState([]);
  const [checkBooks, setCheckBooks] = useState("all"); // تعيين القيمة الافتراضية إلى "all"
  const [showSpan, setShowSpan] = useState(false);
  const [loading, setLoading] = useState(true); // تعيين حالة التحميل إلى true في البداية

  useEffect(() => {
    const fileRef = collection(database, "books");
    const q = query(fileRef, where("primaryKey", "==", "file"));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const fileData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        // Sort files by name
        fileData.sort((a, b) => a.name.localeCompare(b.name));
        setFiles(fileData);
        setLoading(false); // تعيين حالة التحميل إلى false بعد اكتمال جلب البيانات
      }, 
      (error) => {
        setLoading(false); // تعيين حالة التحميل إلى false في حالة حدوث خطأ
      }
    );
    return () => unsubscribe();
  }, []);

  // navebar files
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const openMenu = () => {
      setIsMenuOpened(true);
      setShowSpan(true)
  };
  
  const closeMenu = () => {
      setIsMenuOpened(false);
      setShowSpan(true)
  };

  const { width } = useWindowSize();

  useEffect(() => {
    if (width > 800) {
      closeMenu();
    }
  }, [width]);

  const filteredFiles = checkBooks === "all" ? files : files.filter(file => file.name === checkBooks);

  return (
    <div className='container_files'>
      <div className='button_content'>
        {width < 601 ? (
          !isMenuOpened ? (
            <RxHamburgerMenu className="button_content--icon" onClick={openMenu} />
          ) : (
            <>
              <AiOutlineClose className="button_content--icon" onClick={closeMenu} />
              {showSpan &&
                <div className='mobile-menu'>
                  <div className='mobile-menu__content'>
                    <span className="button__mobile" onClick={() => setCheckBooks("all")}>All</span>
                    <span className="button__mobile" onClick={() => setCheckBooks("Web")}>Web</span>
                    <span className="button__mobile" onClick={() => setCheckBooks("Logic")}>Logic</span>
                    <span className="button__mobile" onClick={() => setCheckBooks("Calculus")}>Calculus</span>
                    <span className="button__mobile" onClick={() => setCheckBooks("Network")}>Network</span>
                  </div>
                </div>
              }
            </>
          )
        ) : (
          <>
            <span className="button" onClick={() => setCheckBooks("all")}>All</span>
            <span className="button" onClick={() => setCheckBooks("Web")}>Web</span>
            <span className="button" onClick={() => setCheckBooks("Logic")}>Logic</span>
            <span className="button" onClick={() => setCheckBooks("Calculus")}>Calculus</span>
            <span className="button" onClick={() => setCheckBooks("Network")}>Network</span>
          </>
        )}
      </div>

      <section id='project' className='service'>
        <h2 className="titels">Files</h2>
        <div className="content">
          {loading ? (
            <span className="notes-pragraph__content--title"><MagnifyingGlass
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="magnifying-glass-loading"
                        wrapperStyle={{}}
                        wrapperClass="magnifying-glass-wrapper"
                        glassColor="#c0efff"
                        color="#e15b64"             
                         /></span>
          ) : (
            filteredFiles.map((doc, index) => (
              <div key={index} className="file-item">
                <FileData
                  img={doc.image}
                  title={doc.title}
                  text={doc.text}
                  link={doc.link}
                  text_li={doc.textlink}
                  onEditClick={() => onEditClick(doc)}
                  onDeleteClick={() => onDeleteClick(doc.id)}
                />
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}